<div>
    <app-gaugechart [setOptions]="null" [value]="null">
    </app-gaugechart>
    <div class="centered">
        {{'Keine aktuellen Daten vorhanden'}}
    </div>
</div>
